import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import classnames from 'classnames';

import t from '../../../lib/I18n';
import MomentPropTypes from "../../../helpers/MomentPropTypes";
import trainTime from '../../../lib/TrainTime';

import Icon from '../../general/Icon';
import PureRenderComponent from '../../PureRenderComponent';
import CalendarDropdown, { DROPDOWN_POSITIONS } from './CalendarDropdown';

class DateSelector extends PureRenderComponent {

    static dropdownPositions = DROPDOWN_POSITIONS;

    static propTypes = {
        datetime: MomentPropTypes.isMoment,
        datetimeFormats: PropTypes.object,
        initialDatetime: MomentPropTypes.isMoment,
        onChange: PropTypes.func,
        min: MomentPropTypes.isMoment,
        max: MomentPropTypes.isMoment,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        dropdownPosition: PropTypes.oneOf(Object.values(DROPDOWN_POSITIONS)),
        srOnly: PropTypes.string
    };

    static defaultProps = {
        datetime: null,
        datetimeFormats: {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'ddd DD MMM',
            lastDay: '[Yesterday]',
            lastWeek: 'ddd DD MMM',
            sameElse: 'ddd DD MMM'
        },
        initialDatetime: trainTime(),
        onChange: _.noop,
        min: null,
        max: null,
        placeholder: t('form.dateSelector.placeholder'),
        disabled: false,
        required: false,
        dropdownPosition: null,
        srOnly: ''
    };

    state = {
        showCalendar: false
    };

    toggleCalendar = (e) => {
        e.preventDefault();
        this.setState({
            showCalendar: !this.state.showCalendar
        }, () => {
            if (this.state.showCalendar) {
                const calendarNode = ReactDOM.findDOMNode(this.refs.calendar);
                calendarNode.scrollIntoView();
            }
        });
    }

    closeCalendar = () => {
        this.setState({
            showCalendar: false
        }, () => {
            this.button.scrollIntoView();
            this.button.focus(); // restore focus
        });
    }

    handleDateChange = (date) => {
        const { datetime, onChange } = this.props;
        let chosenDate = trainTime(date.format('YYYY-MM-DD'));

        if (datetime) {
            chosenDate = chosenDate.set({
                hour: datetime.hour(),
                minute: datetime.minute()
            });
        }

        onChange(chosenDate);

        this.closeCalendar();
    };

    renderTime () {
        const { datetime, datetimeFormats, srOnly } = this.props;

        const text = datetime.calendar(null, datetimeFormats);

        return (
            <span>
                { srOnly &&
                    <span className="sr-only">
                        { srOnly }
                    </span> }
                <time className="clearfix" dateTime={ datetime.format() }>{ text }</time>
                { srOnly &&
                    <span className="sr-only">
                        { t('ariaLabel.clickToChange') }
                    </span> }
            </span>
        );
    }

    render () {
        const { datetime, min, max, placeholder, dropdownPosition, initialDatetime, required } = this.props;
        const { showCalendar } = this.state;

        return (
            <div className={classnames("calendar-dropdown__button", {
                'calendar-dropdown__button--required': required,
            })}>
                <button className="btn btn-box"
                        disabled={ this.props.disabled }
                        onClick={ this.toggleCalendar }
                        ref={(btn) => { this.button = btn; }}
                >
                    <Icon className="pull-right box__icon" icon="calendar" />
                    { required && <Icon icon="mandatory" /> }
                    { datetime ? this.renderTime() : placeholder }
                </button>
                <CalendarDropdown
                    ref="calendar"
                    datetime={ datetime || initialDatetime }
                    onChange={ this.handleDateChange }
                    onClose={ this.closeCalendar }
                    min={ min }
                    max={ max }
                    dropdownPosition={ dropdownPosition }
                    disableOnClickOutside={ !showCalendar }
                    show={ showCalendar }
                    autoFocus />
            </div>
        );
    }
}

export default DateSelector;



// WEBPACK FOOTER //
// ./src/components/search/dates/DateSelector.js